<template>
  <div class="row order-history__title" id="order-history-title">
    <div class="col-12" id="title-col">
      <div
        class="plugin__title d-flex flex-row justify-content-between order-history__plugin-title"
        id="suite-nav"
      >
        {{ lang.get('event_strings.attendee_orders_page.index_title') }}

        <!-- * Leaving searchbar here because I don't yet know what we'd search for but can see it in the future -->
        <!-- <div class="input-group attendee-order__search-bar" id="search-bar">
          <div
            class="input-group-btn attendee-order__clear-search clear_search-attendee-orders search-bar__clear-search"
            v-if="search.length"
            v-on:click="handleClearSearch()"
            id="clear-search"
          >
            <button
              class="btn btn-link agenda__clear-search-button h-100"
              id="clear-search-btn"
              :disabled="fetchingOrders"
            >
              <i aria-hidden="true" class="fas fa-times-circle"></i>
            </button>
          </div>

          <div
            class="input-group-btn agenda__search-button attendee-orders-search-btn search-bar__search-btn"
            id="search-btn"
          >
            <button class="btn btn-link h-100" id="search-icon-btn" :disabled="fetchingOrders">
              <i
                aria-hidden="true"
                class="far fa-search"
                v-on:click="beginSearch"
                
              ></i>
            </button>
          </div>

          <input
            role="tab"
            id="agendaSearch"
            placeholder="Search"
            class="form-control agenda__search-input search-bar__input"
            v-model="search"
            v-on:keyup.enter="beginSearch"
          />

          <div
            role="tab"
            class="input-group-btn agenda__search-right search-bar__search-right"
            id="search-right"
          >
            <button
              class="d-flex justify-content-center align-items-center btn btn-link agenda__search-inner attendee-orders-search-inner h-100 search-right__button"
              v-on:click="beginSearch"
              id="search-submit-btn"
            >
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div> -->
      </div>
    </div>
    <div class="col-12 order-history__content-col" id="content-col">
      <div class="card order-history__card" id="orders-card">
        <div v-if="event && event.attendee_orders_list_page_header" v-html="event.attendee_orders_list_page_header"></div>
        <table class="table order-history__table" id="orders-table">
          <thead class="order-history__table-head" id="table-head">
            <tr class="table-head__row" id="table-head-row">
              <th
                scope="col"
                class="table-head-row__item"
                id="order-number-head"
              >
                {{
                  lang.get('event_strings.attendee_orders_page.order_number')
                }}
              </th>
              <th scope="col" class="table-head-row__item" id="order-date-head">
                {{
                  lang.get('event_strings.attendee_orders_page.order_placed_at')
                }}
              </th>
              <th
                scope="col"
                class="table-head-row__item"
                id="order-amount-head"
              >
                {{
                  lang.get('event_strings.attendee_orders_page.order_amount')
                }}
              </th>
              <th
                scope="col"
                class="table-head-row__item"
                id="order-actions-head"
              >
                {{
                  lang.get('event_strings.attendee_orders_page.order_actions')
                }}
              </th>
            </tr>
          </thead>
          <tbody class="order-history__table-body" id="table-body">
            <tr
              class="table-body__row"
              v-for="order in orders.data"
              :key="order.id"
              @click="openOrder(order.id)"
              :id="'order-row-' + order.id"
            >
              <th
                scope="row"
                class="table-body-row__item"
                id="'order-number-' + order.id"
              >
                {{ order.id }}
              </th>
              <td class="table-body-row__item" id="'order-date-' + order.id">
                {{ order.created_at | formatCreatedAt }}
              </td>
              <td
                class="table-body-row__item table-body-row__item-tooltip"
                :id="'order-amount-' + order.id"
              >
                {{ order.stripe_amount | formatCentsToDollarsDisplay }}
              </td>
              <td class="table-body-row__item" id="'order-action-' + order.id">
                <a
                  @click="openOrder(order.id)"
                  id="'order-link-' + order.id"
                >
                  <i class="fa fa-eye" id="'order-eye-' + order.id"></i>
              </a>
              </td>
            </tr>
          </tbody>
        </table>
        <nav
          aria-label="Page navigation"
          class="order-history__pagination-nav"
          id="pagination-nav"
        >
          <ul class="pagination order-history__pagination" id="pagination">
            <li
              class="page-item pagination__page-item"
              :class="{ disabled: orders.current_page === 1 }"
              id="pagination-previous"
            >
              <a
                class="page-link"
                href="#"
                @click.prevent="fetchOrders(orders.current_page - 1, search)"
                id="previous-page-link"
                >{{ lang.get('event_strings.previous_button') }}</a
              >
            </li>
            <li
              class="page-item pagination__page-item"
              v-for="page in pagesArray"
              :key="page"
              :class="{ active: orders.current_page === page + 1 }"
              :id="'pagination-page-' + (page + 1)"
            >
              <a
                class="page-link"
                href="#"
                @click.prevent="fetchOrders(page + 1, search)"
                :id="'page-link-' + (page + 1)"
                >{{ page + 1 }}</a
              >
            </li>
            <li
              class="page-item pagination__page-item"
              :class="{ disabled: orders.current_page === orders.last_page }"
              id="pagination-next"
            >
              <a
                class="page-link"
                href="#"
                @click.prevent="fetchOrders(orders.current_page + 1, search)"
                id="next-page-link"
                >{{ lang.get('event_strings.next_button') }}</a
              >
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../EventBus';

export default {
  data() {
    return {
      orders: {
        data: [],
        current_page: 1,
        last_page: 1
      },
      fetchingOrders: false,
      search: ''
    };
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  filters: {
    formatCreatedAt: function (value) {
      if (!value) return '';
      return moment(value).format('MMMM Do YYYY, h:mm:ss a');
    },
    formatCentsToDollarsDisplay: function (value) {
      if (!value) return '';
      return '$' + (value / 100).toFixed(2);
    }
  },
  methods: {
    openOrder(id) {
      this.$router.push(`/${id}`);
      $('[data-toggle="tooltip"]').tooltip('disable');

    },
    fetchOrders(page, query = null, pushHistory = true) {
      if (this.fetchingOrders) {
        return;
      }
      if (pushHistory) {
        if (query) {
          this.$router.push({ query: { page: page, query: query } });
        } else {
          this.$router.push({ query: { page: page } });
        }
      }

      Http.get(
        window.Routes.index,
        {
          page: page,
          query: query // Will be null if not provided, so no effect on the request
        },
        response => {
          this.orders = response.data;
          this.$nextTick(() => {
            $('[data-toggle="tooltip"]').tooltip();
            EventBus.$emit('orders-loaded');
          });
        },
        response => {
          console.log(response);
        }
      );
    },

    executeSearch(page = 1) {
      this.fetchOrders(page, this.search);
    },
    beginSearch() {
      if (this.fetchOrders) {
        return;
      }
      this.executeSearch(1);
    },
    handleClearSearch() {
      this.search = '';
      this.fetchOrders(1, null, true);
    }
  },
  computed: {
    pagesArray() {
      // Check if orders.last_page is a number and greater than 0
      if (
        typeof this.orders.last_page === 'number' &&
        this.orders.last_page > 0
      ) {
        // Create an array of length orders.last_page, filled with increasing numbers starting from 1
        return Array.from({ length: this.orders.last_page }, (_, i) => i);
      }
      // If orders.last_page is not a valid number, return an empty array
      return [];
    }
  },
  mounted() {
    // Default to 1 if no page query param is present
    let page = this.$route.query.page ? parseInt(this.$route.query.page) : 1;

    if (this.$route.query.query) {
      // If there's a query parameter, execute a search instead of fetching orders
      this.search = this.$route.query.query;
      this.executeSearch(page, false);
    } else {
      this.fetchOrders(page, null, false);
    }
  }
};
</script>

<style scoped>
.input-group.attendee-order__search-bar {
  max-width: 300px;
}
</style>